import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  paper: {
    border: `1px solid ${Colors.Grey3}`,
    borderRadius: 0,
    boxShadow: '0px 12px 16px rgba(16, 24, 40, 0.08), 0px 4px 6px rgba(16, 24, 40, 0.03)',
  },
  dialogHeader: {
    padding: 24,
  },
  dialogContent: {
    '&.MuiDialogContent-root': {
      padding: '0 24px 16px 24px',
    },
  },
  description: {
    fontFamily: 'Readex Pro',
    fontSize: 16,
    fontWeight: 200,
    lineHeight: '24px',
    letterSpacing: '0.64px',
    color: Colors.Grey10,
  },
  dialogActions: {
    '&.MuiDialogActions-root': {
      padding: 24,
      borderTop: `1px solid ${Colors.Grey3}`,
      justifyContent: 'flex-end',
      gap: 16,
    },
  },
  cancelButton: {
    '&.MuiButton-root': {
      borderColor: Colors.Black,
      borderRadius: 0,
      padding: 12,
      minWidth: 120,
      fontFamily: 'Readex Pro',
      fontSize: 16,
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '0.64px',
      color: Colors.Black,
      textTransform: 'none',
    },
  },
  submitButton: {
    '&.MuiButton-root': {
      backgroundColor: Colors.Black,
      borderRadius: 0,
      padding: 12,
      minWidth: 120,
      fontFamily: 'Readex Pro',
      fontSize: 16,
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '0.64px',
      color: Colors.White,
      textTransform: 'none',
      '&:hover': {
        backgroundColor: Colors.Black,
      },
    },
  },
}));

export default useStyles;
